<template>
  <div id="body-mass-index">
    <div>
      Twój wzrost
      <vue-slider 
        v-model="height" 
        @change="updateBMI"
        :min="140"
        :max="220"
      ></vue-slider>
      {{height}}
    </div>
    <div>
      Twoja waga
      <vue-slider
        v-model="weight" 
        @change="updateBMI"
        :min="40"
        :max="150"
      ></vue-slider>
      {{weight}}
    </div>
    <div>BMI: {{bmi.toFixed(2)}}</div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'

export default {
  name: 'BodyMassIndex',
  components: {
    VueSlider
  },
  methods: {
    updateBMI: function() {
      this.bmi = this.weight / (this.height / 100) ** 2;
    }
  },
  data() {
    return {
      height: 140,
      weight: 40,
      bmi: 0
    }
  }
}
</script>

